// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface IWIPStatusType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class WIPStatusType implements IWIPStatusType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Active WIPStatusType
	**/
    get Active(): IWIPStatusType {
        return this.FromId(1);
    }
    /**
		Returns On Hold WIPStatusType
	**/
    get OnHold(): IWIPStatusType {
        return this.FromId(2);
    }
    /**
		Returns Deleted WIPStatusType
	**/
    get Deleted(): IWIPStatusType {
        return this.FromId(3);
    }
    /**
		Returns Service Complete WIPStatusType
	**/
    get ServiceComplete(): IWIPStatusType {
        return this.FromId(4);
    }
    /**
		Returns Payment Complete WIPStatusType
	**/
    get PaymentComplete(): IWIPStatusType {
        return this.FromId(6);
    }
    /**
		Returns Awaiting Post Payment WIPStatusType
	**/
    get AwaitingPostPayment(): IWIPStatusType {
        return this.FromId(7);
    }
    /**
		Returns Inactive WIPStatusType
	**/
    get Inactive(): IWIPStatusType {
        return this.FromId(8);
    }
    /**
		Returns Finalized WIPStatusType
	**/
    get Finalized(): IWIPStatusType {
        return this.FromId(9);
    }
    /**
		Returns Awaiting Post Finalize WIPStatusType
	**/
    get AwaitingPostFinalize(): IWIPStatusType {
        return this.FromId(10);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Active', displayValue: 'Active', description: 'Active', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'OnHold', displayValue: 'On Hold', description: 'On Hold', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'Deleted', displayValue: 'Deleted', description: 'Deleted', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'ServiceComplete', displayValue: 'Service Complete', description: 'Service Complete', sortOrder: 4, active: true });
        this._dictionary.add('6', { id: 6, value: 'PaymentComplete', displayValue: 'Payment Complete', description: 'Payment Complete', sortOrder: 6, active: true });
        this._dictionary.add('7', { id: 7, value: 'AwaitingPostPayment', displayValue: 'Awaiting Post Payment', description: 'Awaiting Post Payment', sortOrder: 7, active: true });
        this._dictionary.add('8', { id: 8, value: 'Inactive', displayValue: 'Inactive', description: 'Inactive', sortOrder: 8, active: true });
        this._dictionary.add('9', { id: 9, value: 'Finalized', displayValue: 'Finalized', description: 'Finalized', sortOrder: 9, active: true });
        this._dictionary.add('10', { id: 10, value: 'AwaitingPostFinalize', displayValue: 'Awaiting Post Finalize', description: 'Awaiting Post Finalize', sortOrder: 10, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IWIPStatusType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IWIPStatusType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IWIPStatusType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IWIPStatusType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): IWIPStatusType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
